import './index.css';

import BasicInfo from './BasicInfo';
import Price from './Price';
import { Subscription } from '../../../../types/subscription';
import { colors } from '../../../../colors';

interface Props {
  subscription: Subscription;
}

const Header: React.FC<Props> = (props: Props) => {
  const { subscription } = props;

  return (
    <div
      className="detail-container"
      style={{
        position: 'sticky',
        top: 0,
        backgroundColor: colors.black,
        zIndex: 100,
        paddingTop: 15,
        marginLeft: -15,
        marginRight: -15,
        paddingLeft: 15,
        paddingRight: 15,
      }}
    >
      <BasicInfo subscription={subscription} />
      <Price subscription={subscription} />
    </div>
  );
};

export default Header;
